/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate, useParams} from 'react-router-dom'
import {usePermissions} from '../../../../../../hook/permissions'
import {AnimaBaixo} from '../../../../../../_metronic/assets/animation/styles'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {PaymentHistoryListWrapper} from './paymentHistory/components/conditionnig-list/PaymentHistoryList'
import History from './history/History'

import {EditOneProperties} from './editOneProperties/EditOneProperties'
import {Properties, propertyInitValues} from '../../components/property-list/core/_models'
import {DashboardOneProperties} from './dashboardOnePropriedade/dashboardOneProperties'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {KTSVG} from '../../../../../../_metronic/helpers'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {PropertyRegistriesListWrapper} from './propertyRegistry/components/conditionnig-list/PropertyRegistriesList'
import {LicensesListWrapper} from './linkedLicenses/components/linkedLicenses-list/LicensesList'
import {RelatedFilesWrapper} from './relatedFiles/components/relatedFiles-list/relatedFilesList'
import {EvaluationReportsListWrapper} from './evaluationReport/components/evaluationReport-list/EvaluationReportList'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const EditProperties: FC = () => {
  const {show} = usePermissions('Licenças')
  const intl = useIntl()
  const {uuid} = useParams()
  const [properties, setProperties] = useState<Properties>(propertyInitValues)
  const navigate = useNavigate()

  useEffect(() => {
    if (uuid) {
      getProperties(uuid)
    }
  }, [uuid])

  async function getProperties(uuid: string) {
    const {data} = await axios.get(`${API_URL}/sgt/v1/properties/${uuid}`)
    const properties: Properties = data.data
    setProperties(properties)

    return data
  }
  console.log('properties', properties)
  function deleteMsgLicense() {
    const MySwal = withReactContent(Swal)

    MySwal.fire({
      title: intl.formatMessage({id: 'PROPERTIES.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid !== undefined) deleteProperties(uuid)
      }
    })
  }

  async function deleteProperties(uuid: string) {
    try {
      await axios.delete(`${API_URL}/sgt/v1/properties/${uuid}`)
      Swal.fire({
        icon: 'success',
        title: intl.formatMessage({id: 'PROPERTIES.SWAL_DELETE'}),
        showConfirmButton: false,
        timer: 2000,
      })
      navigate('/properties')
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: intl.formatMessage({id: 'PROPERTIES.SWAL_DELETE_ERROR'}),
        showConfirmButton: false,
        timer: 1500,
      })
      navigate('/properties')
    }
  }
  return (
    <>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'PROPERTIES.NAME'}) +
          ' ' +
          (properties.name === undefined ? '' : properties.name)}
      </PageTitle>
      {/* Component Header de navbar. */}

      <ul className='nav'>
        <div
          className='card d-flex justify-content-between g-1 py-3 px-6 mb-3'
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <li className='nav-item  me-1'>
            <a
              className='btn btn-text-gray-600 btn-active-light-primary fs-8 p-3 active'
              data-bs-toggle='tab'
              href='#kt_tab_pane_1'
            >
              {intl.formatMessage({id: 'MENU.DASHBOARD'})}
            </a>
          </li>
          <li className='nav-item me-1'>
            <a
              className='btn btn-text-gray-600 btn-active-light-primary fs-8 p-3'
              data-bs-toggle='tab'
              href='#kt_tab_pane_2'
            >
              {intl.formatMessage({id: 'LICENSES.DOCUMENT_DATA'})}
            </a>
          </li>
          <li className='nav-item me-1'>
            <a
              className='btn btn-text-gray-600 btn-active-light-primary p-3 fs-8'
              data-bs-toggle='tab'
              href='#kt_tab_pane_3'
            >
              {intl.formatMessage({id: 'LICENSES.DOCUMENT_RELATED'})}
            </a>
          </li>

          {show && (
            <li className='nav-item me-1 '>
              <a
                className='btn btn-text-gray-600 btn-active-light-primary p-3 fs-8'
                data-bs-toggle='tab'
                href='#kt_tab_pane_4'
              >
                {intl.formatMessage({id: 'MENU.INSCRIPTION'})}
              </a>
            </li>
          )}
          <li className='nav-item me-1'>
            <a
              className='btn btn-text-gray-600 btn-active-light-primary p-3 fs-8 '
              data-bs-toggle='tab'
              href='#kt_tab_pane_5'
            >
              {intl.formatMessage({id: 'MENU.PAYMENT_HISTORY'})}
            </a>
          </li>
          <li className='nav-item me-1'>
            <a
              className='btn btn-text-gray-600 btn-active-light-primary p-3 fs-8'
              data-bs-toggle='tab'
              href='#kt_tab_pane_6'
            >
              {intl.formatMessage({id: 'MENU.EVALUATION_REPORT'})}
            </a>
          </li>
          <li className='nav-item me-1'>
            <a
              className='btn btn-text-gray-600 btn-active-light-primary p-3 fs-8'
              data-bs-toggle='tab'
              href='#kt_tab_pane_7'
            >
              {intl.formatMessage({id: 'MENU.LINKED_LICENSE'})}
            </a>
          </li>
          <li className='nav-item me-1'>
            <a
              className='btn btn-text-gray-600 btn-active-light-primary p-3 fs-8'
              data-bs-toggle='tab'
              href='#kt_tab_pane_8'
            >
              {intl.formatMessage({id: 'MENU.HISTORY'})}
            </a>
          </li>

          <li className='nav-item me-1'>
            <a
              type='button'
              data-bs-toggle='tab'
              href='#kt_tab_pane_9'
              className='btn btn-sm btn-icon btn-light-danger p-1'
              title='Limpar'
            >
              <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-5' />
            </a>
          </li>
        </div>
      </ul>

      {/* Conteudo da navbar de dashboard */}
      <div className='tab-content' id='myTabContent'>
        <div className='tab-pane fade active show ' id='kt_tab_pane_1' role='tabpanel'>
          <div className='py-0'>
            <AnimaBaixo>
              <DashboardOneProperties data={properties} />
            </AnimaBaixo>
          </div>
        </div>
        {/* Conteudo da navbar de edição dos dados da licença */}

        <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'>
          <EditOneProperties data={properties} />
        </div>
        <div className='tab-pane fade' id='kt_tab_pane_3' role='tabpanel'>
          <RelatedFilesWrapper data={properties} />
        </div>

        <div className='tab-pane fade' id='kt_tab_pane_4' role='tabpanel'>
          <PropertyRegistriesListWrapper />
        </div>

        <div className='tab-pane fade' id='kt_tab_pane_5' role='tabpanel'>
          <PaymentHistoryListWrapper data={properties} />
        </div>

        <div className='tab-pane fade' id='kt_tab_pane_6' role='tabpanel'>
          <EvaluationReportsListWrapper />
        </div>

        <div className='tab-pane fade' id='kt_tab_pane_7' role='tabpanel'>
          <LicensesListWrapper />
        </div>

        <div className='tab-pane fade' id='kt_tab_pane_8' role='tabpanel'>
          <History />
        </div>
        <div className='tab-pane fade' id='kt_tab_pane_9' role='tabpanel'>
          <div className=''>
            <div id='kt_account_deactivate' className='card '>
              <div className='card-body border-top'>
                <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed  p-6'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen044.svg'
                    className='svg-icon-2tx svg-icon-danger me-4'
                  />

                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <h4 className='text-gray-800 fw-bolder'>
                        Você está excluindo sua Propriedade
                      </h4>
                      <div className='fs-7 text-gray-600'>
                        Ao executar essa ação ação não será possivél revertê-la .
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex justify-content-end py-5 px-9'>
                <button
                  id='kt_account_deactivate_account_submit'
                  type='submit'
                  className='btn btn-sm btn-light-danger fw-bold'
                  onClick={deleteMsgLicense}
                >
                  {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {EditProperties}
